export enum OauthClientDetailsApplicationKind {
	STUDIO = 'studio',
	DESIGNER = 'designer',
	CX_SUITE = 'cx-suite',
	CB_LINK = 'cb-link',
	EXTERNAL = 'external',
	QUALTRICS = 'qualtrics'
}